var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.classes},[_c('router-view')],1),_vm._v(" "),_c('g-row',{staticClass:"g-pb-6",attrs:{"type":"flex","justify":"space-around"}},[_c('powered-by-grin',{staticStyle:{"text-align":"center"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }